import React, { useState, useEffect } from "react";
import { FaEnvelope } from "react-icons/fa";
import { Dropdown } from "react-bootstrap";

const logo = process.env.PUBLIC_URL + "/assets/images/transparente.png";
const portugalFlag = process.env.PUBLIC_URL + "/assets/images/pt.png";
const enFlag = process.env.PUBLIC_URL + "/assets/images/en.png";

const Error = () => {
  const [language, setLanguage] = useState("PT");

  useEffect(() => {
    const title = language === "PT" ? "Ocorreu um erro" : "An error occurred";
    document.title = `${title} | Casas do Nabão`;
  }, [language]);

  return (
    <>
      <div className="error-page-wrapper">
        <div className="error-page-container">
          <Dropdown align="end">
            <Dropdown.Toggle variant="light" id="dropdown-basic">
              {language === "PT" ? (
                <img src={portugalFlag} alt="pt" width="20" height="20" />
              ) : (
                <img src={enFlag} alt="en" width="20" height="20" />
              )}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setLanguage("PT")}>
                <img src={portugalFlag} alt="pt" width="20" height="20" /> PT
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setLanguage("EN")}>
                <img src={enFlag} alt="en" width="20" height="20" /> EN
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <img src={logo} alt="Logo" className="error-page-logo" />
          <div className="error-message">
            {language === "PT" ? (
              <>
                <h1>Ocorreu um erro</h1>
                <p>Por favor, tente novamente mais tarde.</p>
                <p>
                  Se o erro persistir, por favor contacte-nos. Pedimos desculpa
                  pelos incómodos causados.
                </p>
              </>
            ) : (
              <>
                <h1>An error occurred</h1>
                <p>Please try again later.</p>
                <p>
                  If the error persists, please contact us. We apologize for any
                  inconvenience caused.
                </p>
              </>
            )}
            <p className="mb-2">
              <FaEnvelope className="me-2" />
              <a href={`mailto:geral@casasdonabao.pt`} className="text-black">
                geral@casasdonabao.pt
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Error;
